import { BadgeContainer } from '@repo/editor/src/components/PricingPlan/styles';
import { withEventScope } from '@repo/event-processor';
import CheckIcon from '@repo/ui/components/Icon/v2/CheckIcon';
import { P2 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';

import LinkButton from 'components/LinkButton/LinkButton';
import { FlexColumn, FlexRow } from 'styles/layouts';

import { ReactComponent as KittlPlusLogo } from '../utilities/icons/assets/kittlPlusLogo.svg';

import {
  BannerWrapper,
  TextWrapper,
  ButtonWrapper,
  BannerImage,
} from './styles';

const FeatureItem = ({
  text,
  isBold,
  hasIcon,
  isIntroducingFeature,
}: {
  text: string;
  isBold?: boolean;
  hasIcon?: boolean;
  isIntroducingFeature?: boolean;
}) => (
  <FlexRow alignItems="center" gap="12px">
    {hasIcon && (
      <CheckIcon height="16px" theme={{ color: themeStyle.highlight }} />
    )}
    <P2>
      {isIntroducingFeature ? <b>Introducing:&nbsp;</b> : null}
      {isBold ? <b>{text}</b> : text}
    </P2>
  </FlexRow>
);

/* 
  This component is a new banner added to the pricing page which promotes Kittl+ for business accounts. 
  It highlights the features available for business accounts and contains a link to contact sales.
*/

const KittlPlusBanner: React.FC = () => (
  <BannerWrapper>
    <TextWrapper>
      <FlexColumn gap="32px">
        <FlexColumn gap="12px">
          <FlexRow alignItems="center">
            <KittlPlusLogo color={themeStyle.varInkMain} />
            <BadgeContainer
              style={{
                background: `${themeStyle.highlight}`,
                color: `${themeStyle.inkBase}`,
                fontWeight: `${themeStyle.fontBold}`,
                borderRadius: '360px',
              }}
            >
              FOR BUSINESS
            </BadgeContainer>
          </FlexRow>
          <P2>
            For organisations that need advanced collaboration features,
            security, and unlimited usage limits.
          </P2>
        </FlexColumn>
        <FlexColumn gap="12px">
          <FeatureItem isBold text="Everything in Expert and..." />
          <FeatureItem
            hasIcon
            text="Enhanced collaboration: teams, shared folders and files"
          />
          <FeatureItem
            hasIcon
            text="Unlimited projects, Kittl AI credits and storage"
          />
          <FeatureItem hasIcon text="Dedicated account manager" />
          <FeatureItem
            hasIcon
            text="Advanced security, privacy and governance"
          />
          <FeatureItem
            hasIcon
            isIntroducingFeature
            text="Kittl custom design services (Additional cost)"
          />
        </FlexColumn>
        <ButtonWrapper>
          <LinkButton
            href="/plus"
            label="Contact Sales"
            target="_blank"
            theme={{
              backgroundColor: `${themeStyle.highlight}`,
              backgroundColorDark: `${themeStyle.highlight}`,
              borderColor: `${themeStyle.highlight}`,
              borderColorDark: `${themeStyle.highlight}`,
              backgroundActiveColor: `${themeStyle.highlight}`,
              borderActiveColor: `${themeStyle.highlight}`,
              backgroundActiveColorDark: `${themeStyle.highlight}`,
              borderActiveColorDark: `${themeStyle.highlight}`,
            }}
            width="100%"
          />
        </ButtonWrapper>
      </FlexColumn>
    </TextWrapper>
    <BannerImage alt="Kittl+ banner" src="/images/kittlPlusCollaboration.png" />
  </BannerWrapper>
);

export default withEventScope(KittlPlusBanner, { feature: 'kittlPlusBanner' });
